import { useCallback, useEffect } from 'react';

const elements = ['INPUT', 'TEXTAREA'];

export const useKeyboardShift = (wrapperRef, initialPadding, shouldAddHeight=false) => {
    const handleFocus = useCallback(() => {
        if (!wrapperRef?.current) {
            return;
        }

        wrapperRef.current.style.paddingBottom = '350px';
        if (shouldAddHeight) {
            wrapperRef.current.style.maxHeight = 'calc(100svh + 350px)';
            wrapperRef.current.style.minHeight = 'calc(100svh + 350px)';
        }
    }, [wrapperRef, shouldAddHeight]);

    const handleBlur = useCallback(() => {
        if (!wrapperRef?.current) {
            return;
        }

        wrapperRef.current.style.paddingBottom = initialPadding;
        if (shouldAddHeight) {
            wrapperRef.current.style.maxHeight = '100svh';
            wrapperRef.current.style.minHeight = '100svh';
        }
    }, [wrapperRef, initialPadding, shouldAddHeight]);

    const handleClick = useCallback(
        (event) => {
            if (!window?.Telegram?.WebApp?.initDataUnsafe) {
                return;
            }

            const target = event.target;
            if (elements.includes(target.tagName)) {
                handleFocus();
            } else {
                handleBlur();
            }
        },
        [handleFocus, handleBlur],
    );

    useEffect(() => {
        window.addEventListener('click', handleClick);

        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, [handleClick]);
};
